import { Component } from '@angular/core';


@Component({
  selector: 'pricing',
  templateUrl: 'pricing.component.html',
  styleUrls: ['pricing.component.sass']
})
export class PricingComponent {}



// WEBPACK FOOTER //
// ./src/app/pages/pricing/pricing.component.ts